export const splitByLastDoubleUnderscore = (str?: string) => {
  if (!str) return [undefined, undefined];

  const lastIndex = str.lastIndexOf('__');
  if (lastIndex === -1) return [str]; // no '__' found

  const part1 = str.slice(0, lastIndex);
  const part2 = str.slice(lastIndex + 2);
  return [part1, part2];
};
